import React from "react";
import styles from "./IconButton.module.css";

interface Props
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
  label?: string;
  stopPropagation?: boolean;
}

export const IconButton: React.FC<Props> = ({
  icon,
  label,
  className,
  disabled,
  stopPropagation = true,
  onClick,
  ...rest
}) => {
  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    if (stopPropagation) e.stopPropagation();
    if (disabled) return;
    onClick?.(e);
  };

  return (
    <button
      type="button"
      className={`${styles.button} ${className ?? ""}`}
      disabled={disabled}
      onClick={handleClick}
      {...rest}
    >
      {icon}
      {label && <span className={styles.label}>{label}</span>}
    </button>
  );
};